import Logger from "../lib/logger"
import { Turbo } from "@hotwired/turbo-rails"

/**
 * Reusable confirmation function using a Bootstrap 5 modal.
 * Used both by Turbo's native confirmation and manually in Stimulus controllers.
 * 
 * @param {string} message - The message to display
 * @param {Element} element - The element that triggered the confirmation (optional)
 * @returns {Promise<boolean>} - Resolves to true if confirmed, false otherwise
 */
export function confirm(message, element = null) {
  const modalElement = document.getElementById("turbo-confirm-modal")
  const messageElement = document.getElementById("turbo-confirm-message")
  const okButton = document.getElementById("turbo-confirm-ok")
  const cancelButton = document.getElementById("turbo-confirm-cancel")

  if (!modalElement || !messageElement || !okButton || !cancelButton) {
    Logger.warn("⚠️ Turbo confirm modal elements not found, falling back to window.confirm")
    return Promise.resolve(window.confirm(message))
  }

  messageElement.textContent = message
  
  // Use the bootstrap object globally exposed in application.js
  const modal = new window.bootstrap.Modal(modalElement)
  
  return new Promise((resolve) => {
    const onConfirm = () => {
      cleanup()
      modal.hide()
      resolve(true)
    }
    
    const onCancel = () => {
      cleanup()
      modal.hide()
      resolve(false)
    }

    const cleanup = () => {
      okButton.removeEventListener("click", onConfirm)
      cancelButton.removeEventListener("click", onCancel)
      modalElement.removeEventListener("hidden.bs.modal", onCancel)
    }

    okButton.addEventListener("click", onConfirm)
    cancelButton.addEventListener("click", onCancel)
    
    // Ensure we resolve false if the modal is closed via Escape or clicking outside
    modalElement.addEventListener("hidden.bs.modal", onCancel)

    modal.show()
  })
}

/**
 * Custom Turbo Confirmation Handler Initialization
 */
export function setupTurboConfirm() {
  Turbo.config.forms.confirm = confirm
}

